export default __webpack_public_path__ + "audio/6773eff79b23363e056d7c06423537ac.mp3";